"use client";

import { type ReactNode, useEffect } from "react";
import { dispatchKeyEvent } from "./dispatch";

// Importing the barrel installs every binding at module scope. Menus read
// shortcut labels during render, so this must not wait for an effect.
import "./index";

/**
 * Mounts the window-level half of shortcut dispatch.
 *
 * Bubble phase on purpose: ProseMirror, cmdk and Radix all attach closer to the
 * element and get first refusal, so a menu or dialog that genuinely wants a key
 * still wins. Anything they leave unhandled reaches the registry.
 */
export function ShortcutProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => dispatchKeyEvent(event);
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  return <>{children}</>;
}
